import { AfterViewInit, ChangeDetectionStrategy, Component, Input } from '@angular/core';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { Constants } from 'src/app/admin-core/constants';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HelperService } from '@coreservices';
Swiper.use([Navigation, Pagination]);

@Component({
  standalone: false,
  selector: 'app-product-image-slider-modal',
  // Eager: Angular 22 defaults every component to OnPush, which would leave this view
  // unpainted after its subscribe callbacks (see app.component.ts for the full note).
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './product-image-slider-modal.component.html',
  styleUrls: ['./product-image-slider-modal.component.css'],
})
export class ProductImageSliderModalComponent implements AfterViewInit {
  @Input() public selectedQuoteProduct: any;
  Constants = Constants;
  isLoading = false;
  constructor(
    public activeModel: NgbActiveModal,
    public helperService: HelperService
  ) { }

  ngAfterViewInit(): void {
    new Swiper('.mySwiper', {
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }

  getFileName(path: string): string {
    return path.split('/').pop() || '';
  }

  closeModal() {
    this.activeModel.close();
  }
}
